module.exports = __webpack_public_path__ + "static/media/ss_3_en.878903ce.jpg";